"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var publicTypes_1 = require("../publicTypes");
var types_1 = require("../types");
/**
 * Parses object in format { "key.key2.key3" : value } into { key: { key2: {key3: value } } }
 * @param object object to parse
 * @param key string to split
 * @param value value to make it equal to
 */
function set(object, key, value) {
    var current = object;
    var tokens = key.split('.');
    var last = tokens.pop();
    tokens.forEach(function (token) {
        current[token] = typeof current[token] == 'object' ? current[token] : {};
        current = current[token];
    });
    current[last] = value;
    return object;
}
exports.set = set;
/**
 * Should invert the object (keys becomes values and values becomes keys)
 * @param object
 */
function invert(object) {
    var returnee = {};
    for (var key in object) {
        // eslint-disable-next-line no-prototype-builtins
        if (!object.hasOwnProperty(key)) {
            continue;
        }
        returnee[object[key]] = key;
    }
    return returnee;
}
exports.invert = invert;
function signedInfuraLink(infura, network) {
    if (network === void 0) { network = 'mainnet'; }
    return "https://" + network + ".infura.io/v3/" + infura;
}
exports.signedInfuraLink = signedInfuraLink;
// Need more sophisticated way to determine if the contract is Legacy
function isLegacyResolver(resolverAddress) {
    if (isWellKnownLegacyResolver(resolverAddress)) {
        return true;
    }
    if (isUpToDateResolver(resolverAddress)) {
        return false;
    }
    // TODO we need to make an IO call to the contract to check the interface
    return false;
}
exports.isLegacyResolver = isLegacyResolver;
function isWellKnownLegacyResolver(resolverAddress) {
    return [
        '0xa1cac442be6673c49f8e74ffc7c4fd746f3cbd0d',
        '0x878bc2f3f717766ab69c0a5f9a6144931e61aed3',
    ].includes(resolverAddress.toLowerCase());
}
exports.isWellKnownLegacyResolver = isWellKnownLegacyResolver;
function isUpToDateResolver(resolverAddress) {
    return (resolverAddress.toLowerCase() ===
        '0xb66dce2da6afaaa98f2013446dbcb0f4b0ab2842');
}
exports.isUpToDateResolver = isUpToDateResolver;
function hexToBytes(hexString) {
    var hex = hexString.replace(/^0x/i, '');
    var bytes = [];
    for (var c = 0; c < hex.length; c += 2) {
        bytes.push(parseInt(hex.substr(c, 2), 16));
    }
    return bytes;
}
exports.hexToBytes = hexToBytes;
/** @internal */
var CRYPTO_RESOLVER_ADVANCED_EVENTS_STARTING_BLOCK = '0x960844';
function getStartingBlock(contract, tokenId) {
    return __awaiter(this, void 0, void 0, function () {
        var logs, lastResetEvent;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, contract.fetchLogs('ResetRecords', tokenId)];
                case 1:
                    logs = _a.sent();
                    lastResetEvent = logs[logs.length - 1];
                    return [2 /*return*/, ((lastResetEvent === null || lastResetEvent === void 0 ? void 0 : lastResetEvent.blockNumber) ||
                            CRYPTO_RESOLVER_ADVANCED_EVENTS_STARTING_BLOCK)];
            }
        });
    });
}
exports.getStartingBlock = getStartingBlock;
function isStringArray(value) {
    if (value instanceof Array) {
        return value.every(function (item) { return typeof item === 'string'; });
    }
    return false;
}
exports.isStringArray = isStringArray;
function isNullAddress(key) {
    if (!key) {
        return true;
    }
    return Object.values(types_1.NullAddresses).includes(key);
}
exports.isNullAddress = isNullAddress;
function isSupportedChainVersion(obj) {
    return Object.values(publicTypes_1.TickerVersion).includes(obj);
}
exports.isSupportedChainVersion = isSupportedChainVersion;
